/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteAllMemoriesApp} from '../api'

export const useMutationDeleteAllMemoriesApp = createReactQueryMutationHook('deleteAllMemoriesApp', deleteAllMemoriesApp)
